import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-required-form-confirmation-model',
  templateUrl: './required-form-confirmation-model.component.html',
  styleUrl: './required-form-confirmation-model.component.scss'
})
export class RequiredFormConfirmationModelComponent {
  @Input() title!: string;
  @Input() message!: string;
  @Input() button!: string;
  @Input() FieldName!: string;

  constructor(public activeModal: NgbActiveModal) { }

  onButtonClick(action: string) {
    this.activeModal.close(action);
    this.activeModal.dismiss(); // Pass the action back to the parent
  }
  onCancel() {
    this.activeModal.dismiss(); // Dismiss the modal without action
  }
  onClose(type: string) {
    this.activeModal.close(type);
    this.activeModal.dismiss();
  }
}
